import { ArchivedBadge } from '@go-client/components/Common/ArchivedBadge';
import { BubbleBadge } from '@go-client/components/BubbleUI';
import React, { FC } from 'react';
import { ActionChip } from '@go-client/components/UserRecords/UserRecords';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { hashStringToColor } from '@go-shared/lib/utils';

export const UserActionSummary: FC<UserActionLog> = ({
  action,
  body,
  query,
  method,
  summary,
  url,
}) => {
  let strategy = '';
  if (url.includes('template-fragment/unlink') && body?.linkFragments?.length) {
    strategy = body.linkFragments[0].unlinkStrategy === 'full' ? 'Unlink and Clear' : 'Unlink Only';
  }

  return (
    <>
      <ActionChip action={action} />

      {url.includes('archive') && (
        <>
          {action === 'PROPERTY UPDATED' && (
            <ArchivedBadge
              variant="dirt"
              text={query.newState === 'true' ? 'Archived' : 'Unarchived'}
            />
          )}
          {action !== 'PROPERTY UPDATED' && (
            <ArchivedBadge variant="dirt" text={body.archived ? 'Archived' : 'Unarchived'} />
          )}
        </>
      )}

      {url.includes('lock') && (
        <BubbleBadge variant={method === 'POST' ? 'grape' : 'ocean'} className="p-1-i">
          {method === 'POST' ? 'Locked' : 'Unlocked'}
        </BubbleBadge>
      )}

      {url.includes('template-fragment/unlink') && (
        <>
          <BubbleBadge color={hashStringToColor(strategy)} className="p-1-i">
            {strategy}
          </BubbleBadge>
        </>
      )}

      <code className={`mt-4 block url`}>{url}</code>

      <div className={`mt-4`}>
        {summary &&
          Object.keys(summary).map((element, idx) => (
            <BubbleBadge variant="smoke" className="px-3 py-1 mr-3" key={idx}>
              {summary[element]?.name}
            </BubbleBadge>
          ))}
      </div>
    </>
  );
};
